import Driver from './driver';

export default class LeagueTeam {
    id: number;
    userId: number;
    raceId: number;
    tieBreaker: number | null;
    finish1: Driver | number;
    finish2: Driver | number;
    finish3: Driver | number;
    pick1: Driver | number;
    pick2: Driver | number;
    pick3: Driver | number;
    pick4: Driver | number;
    pick5: Driver | number;
    pick6: Driver | number;
    pick7: Driver | number;
    pick8: Driver | number;
    teamName: string;
    createdDate: Date;
    modifiedDate: Date;
    racePoints: number;
    bonusPoints: number;
    finishFirstPoints: number = 0;
    finishSecondPoints: number = 0;
    finishThirdPoints: number = 0;
    totalPoints: number = 0;
    constructor(starter?: any) {
        starter = starter || {};
        this.id = starter.id == null ? null : starter.id;
        this.userId = starter.userId || null;
        this.raceId = starter.raceId || null;
        this.teamName = "";
        this.tieBreaker = starter.tieBreaker
            ? parseFloat(starter.tieBreaker.toString())
            : null;
        this.finish1 = starter.finish1 || null;
        this.finish2 = starter.finish2 || null;
        this.finish3 = starter.finish3 || null;
        this.pick1 = starter.pick1 || null;
        this.pick2 = starter.pick2 || null;
        this.pick3 = starter.pick3 || null;
        this.pick4 = starter.pick4 || null;
        this.pick5 = starter.pick5 || null;
        this.pick6 = starter.pick6 || null;
        this.pick7 = starter.pick7 || null;
        this.pick8 = starter.pick8 || null;
        this.createdDate = starter.createdDate
            ? new Date(starter.createdDate)
            : new Date();
        this.modifiedDate = starter.modifiedDate
            ? new Date(starter.modifiedDate)
            : new Date();
        this.racePoints = starter.racePoints || 0;
        this.bonusPoints = starter.bonusPoints || 0;
        this.finishFirstPoints = starter.finishFirstPoints || 0;
        this.finishSecondPoints = starter.finishSecondPoints || 0;
        this.finishThirdPoints = starter.finishThirdPoints || 0;
        this.totalPoints = starter.totalPoints || 0;
    }

    getFinishPoints() {
        return [
            this.finishFirstPoints,
            this.finishSecondPoints,
            this.finishThirdPoints
        ]; // first second third
    }

    toPayload() {
        let payload: any = {
            id: this.id,
            userId: this.userId,
            raceId: this.raceId,
            tieBreaker: this.tieBreaker || null,
            finish1: this.finish1 || null,
            finish2: this.finish2 || null,
            finish3: this.finish3 || null,
            pick1: this.pick1 || null,
            pick2: this.pick2 || null,
            pick3: this.pick3 || null,
            pick4: this.pick4 || null,
            pick5: this.pick5 || null,
            pick6: this.pick6 || null,
            pick7: this.pick7 || null,
            pick8: this.pick8 || null
        };
        return payload;
    }
}
